import Button, { ButtonProps } from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { maxWidth } from "@mui/system";
import { theme as _theme } from "../../helpers/theme"

export const StyledButton = styled(Button)<ButtonProps>(({ theme }) => ({
  height: `${_theme.buttonSize.projFormH}`,
  color: `${_theme.colors.white}`,
  borderRadius: `${_theme.radius.thirdRadius}`,
  backgroundColor: `${_theme.colors.blue01_active}`,
  fontWeight: `${_theme.fontWeight.normal}`,
  fontFamily: `${_theme.fonts.interMedium}`,
  textTransform: 'none',
  fontSize: "14px",

  ":disabled": {
    backgroundColor: `${_theme.colors.blue03_discabled}`,
    color: `${_theme.colors.white}`,
  },
  "&:hover": {
    backgroundColor: `${_theme.colors.blue02_hover}`,
  },
}));

